import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  limit_boules: {
    count: 0,
    data: [],
    num_pages: 1,
    page: 1,
    page_size: "5",
  },
};

const slice = createSlice({
  name: "limitboule",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET LIMIT BOULE
    getLimitBouleSuccess(state, action) {
      state.isLoading = false;
      state.limit_boules = action.payload;
    },

    // ADD LIMIT BOULE
    addLimitBouleSuccess(state, action) {
      const limitboule = action.payload;
      state.limit_boules.data.push(limitboule);
      state.limit_boules.count += 1;
    },

    // UPDATE LIMIT BOULES
    updateLimitBouleSuccess(state, action) {
      const limitboule = action.payload;
      if (state.limit_boules && state.limit_boules.data) {
        const limitbouleIndex = state.limit_boules?.data?.findIndex(
          (obj) => obj.id === limitboule.id
        );
        if (limitbouleIndex !== -1) {
          state.isLoading = false;
          state.limit_boules.data[limitbouleIndex] = limitboule;
        }
      } else {
        state.limit_boules = { data: [] };
        state.limit_boules.data.push(limitboule);
      }
    },

    // DELETE LIMIT BOULE
    deleteLimitBouleSuccess(state, action) {
      const deletedLimitBouleId = action.payload;
      state.limit_boules.data = state.limit_boules.data.filter(
        (limitboule) => limitboule.id !== deletedLimitBouleId
      );
      state.isLoading = false;
    },

    // DELETE LIMIT BOULES
    deleteLimitBoulesSuccess(state, action) {
      const deletedLimitBouleIds = action.payload;
      state.limit_boules.data = state.limit_boules.data.filter(
        (limitboule) => !deletedLimitBouleIds.includes(limitboule.id)
      );
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addLimitBouleSuccess,
  updateLimitBouleSuccess,
  deleteLimitBouleSuccess,
  deleteLimitBoulesSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function getLimitBoules(page = 1, rowsPerPage = 5) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/dashboard/limit-boule?page=${page}&page_size=${rowsPerPage}`
      );
      dispatch(slice.actions.getLimitBouleSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getLimitBoule(keyId) {
  const response = await axios.get(
    `/api/dashboard/limit-boule-id?keyId=${keyId}`
  );
  return response.data;
}

export async function addLimitBoule(data) {
  const response = await axios.post(`/api/dashboard/limit-boule`, data);
  return response.data;
}

export async function updateLimitBoule(data) {
  const response = await axios.put(`/api/dashboard/limit-boule`, data);
  return response.data;
}

export async function deleteLimitBoule(keyId) {
  const response = await axios.delete(`/api/dashboard/limit-boule/${keyId}/`);
  return response.data;
}

export async function deleteLimitBoules(keyIds) {
  const response = await axios.delete(`/api/dashboard/limit-boule-id`, {
    data: { keyIds },
  });
  return response.data;
}
